import React from 'react';

function Close({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = '#fff',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.707 17.293L13.414 12l5.293-5.292.001-.001c.18-.181.292-.431.292-.707 0-.552-.447-1-1-1-.276 0-.526.112-.706.293l-.001.001L12 10.586 6.708 5.294l-.001-.001C6.525 5.112 6.275 5 6 5c-.553 0-1 .448-1 1 0 .276.111.526.293.707l.001.001L10.586 12l-5.292 5.293-.001.001c-.182.181-.293.43-.293.706 0 .553.447 1 1 1 .275 0 .525-.112.707-.292l.001-.001L12 13.414l5.293 5.293.001.001c.18.18.43.292.706.292.553 0 1-.447 1-1 0-.276-.112-.525-.292-.706l-.001-.001z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}
export default Close;
